import { Mail, MapPin, Clock, Instagram, Twitter, Facebook, Youtube } from "lucide-react";

const BG = "https://images.unsplash.com/photo-1688678004647-945d5aaf91c1?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";

const INFO = [
  { icon: Mail, label: "General enquiries", value: "contact@exclusivestreams.com", href: "mailto:contact@exclusivestreams.com", id: "email" },
  { icon: Mail, label: "Partnerships", value: "partners@exclusivestreams.com", href: "mailto:partners@exclusivestreams.com", id: "partners-email" },
  { icon: MapPin, label: "Studio", value: "100 Sunset Boulevard, Los Angeles, CA", id: "address" },
  { icon: Clock, label: "Hours", value: "Mon – Fri, 9:00 – 18:00 PT", id: "hours" },
];

const SOCIAL = [
  { icon: Instagram, label: "Instagram", id: "instagram" },
  { icon: Twitter, label: "X / Twitter", id: "twitter" },
  { icon: Facebook, label: "Facebook", id: "facebook" },
  { icon: Youtube, label: "YouTube", id: "youtube" },
];

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <section className="relative h-[56vh] min-h-[420px] overflow-hidden">
        <img src={BG} alt="Cinema screen in a dark room" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#0a0a0a]/70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] to-transparent" />
        <div className="relative mx-auto flex h-full max-w-7xl items-end px-5 pb-16 md:px-10">
          <div className="hero-copy">
            <p className="eyebrow text-[#D4AF37]">Contact</p>
            <h1 className="mt-4 font-display text-4xl font-bold text-white sm:text-5xl lg:text-6xl">Let's talk pictures.</h1>
            <p className="mt-4 max-w-lg text-sm text-neutral-300 md:text-base">Questions, partnerships or press. Reach us directly through the channels below.</p>
          </div>
        </div>
      </section>

      <section className="mx-auto grid max-w-7xl gap-6 px-5 py-20 md:grid-cols-2 md:px-10">
        {INFO.map(({ icon: Icon, label, value, href, id }) => (
          <div key={id} data-testid={`contact-${id}`} className="group rounded-2xl border border-white/10 bg-[#121212] p-8 transition-colors duration-300 hover:border-[#D4AF37]/40">
            <Icon className="h-5 w-5 text-[#D4AF37]" />
            <p className="eyebrow mt-6 text-neutral-500">{label}</p>
            {href ? (
              <a href={href} className="mt-2 block font-display text-xl text-white transition-colors duration-300 hover:text-[#D4AF37] md:text-2xl">{value}</a>
            ) : (
              <p className="mt-2 font-display text-xl text-white md:text-2xl">{value}</p>
            )}
          </div>
        ))}
      </section>

      <section className="mx-auto max-w-7xl px-5 pb-10 md:px-10">
        <p className="eyebrow text-[#D4AF37]">Follow along</p>
        <div className="mt-6 flex flex-wrap gap-4">
          {SOCIAL.map(({ icon: Icon, label, id }) => (
            <a
              key={id}
              href="#"
              onClick={(e) => e.preventDefault()}
              aria-label={label}
              data-testid={`social-${id}`}
              className="flex items-center gap-3 rounded-full border border-white/15 px-5 py-3 text-sm text-neutral-300 transition-colors duration-300 hover:border-[#D4AF37] hover:text-[#D4AF37]"
            >
              <Icon className="h-4 w-4" /> {label}
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}
